import BusinessPrivacy from './ui/BusinessPrivacy';

const PrivacyPage = () => {
  return <BusinessPrivacy />;
};

export default PrivacyPage;
